import React from 'react'
import PropTypes from 'prop-types'

import Link from '@material-ui/core/Link'
import CommonButton from '../CommonButton'
import intlPropTypes from '../../types/intlPropTypes'
import useDataLayer from '../../hooks/useDataLayer'

export const RegisterCTA = ({ href, label, id, onClick, isEloThemeActive, ...props }) => {
  const dataLayer = useDataLayer()

  const setDataLayer = (buttonId, buttonText) => {
    dataLayer.push({
      event: 'buttonClick',
      buttonId,
      buttonText
    })
  }

  const onClickFunctions = () => {
    setDataLayer(id, label)
    if (onClick) {
      onClick()
    }
  }
  return (
    <CommonButton
      component={Link}
      href={href === '#' ? void(0) : href}
      rel="noopener noreferrer"
      onClick={onClickFunctions}
      isEloThemeActive={isEloThemeActive}
      {...props}
    >
      {label}
    </CommonButton>
  )
}

RegisterCTA.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  intl: PropTypes.shape(intlPropTypes),
  onClick: PropTypes.func,
  isEloThemeActive: PropTypes.bool
}

export default RegisterCTA
